import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import authReducer from '../features/auth/authSlice';
import guildsReducer from '../features/guilds/guildsSlice';
import uiReducer from '../features/ui/uiSlice';
import { guildsApi } from '../features/guilds/guildsApi';
import { templatesApi } from '../features/templates/templatesApi';
import { authApi } from '../features/auth/authApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    guilds: guildsReducer,
    ui: uiReducer,
    [guildsApi.reducerPath]: guildsApi.reducer,
    [templatesApi.reducerPath]: templatesApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore Discord SDK instances in state
        ignoredActions: ['auth/setAuth'],
        ignoredPaths: ['auth.guildMember'],
      },
    }).concat(guildsApi.middleware, templatesApi.middleware, authApi.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
